module.exports = __webpack_public_path__ + "static/img/icon-upload-check.bebc3345.svg";